///GEOLOCATION --- GET COUNTRY ///

function getAjax(url, success) {
  var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
  xhr.open('GET', url);
  xhr.onreadystatechange = function() {
    if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
  };
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.send();
  return xhr;
}

getAjax('https://ipinfo.io/json', function(data) {
  var theData = JSON.parse(data);
  var theCountry = theData.country;
  console.log(theData);
  console.log(theCountry);    
  if (theCountry === 'MX') {
    $('.is_mx').css('display', 'inline-block');
    $('.is_mx_btn').css('display', 'inline-block');
  } else {
    $('.isnt_mx').css('display', 'inline-block');
  };
  $('.the_country').html(theCountry);
});